import { useAchievementTypes, useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { getFormattedDate } from 'lib/common';
import { EmptyIndicator } from 'components/common';

import type { Achievement } from 'shared-types';

interface Props {
  date: string;
  type: Achievement['type'];
}

const AchievementCompletionItemsCleared = ({ date, type }: Props) => {
  const { messages } = useReduxState();

  const { icon } = useAchievementTypes({ type });

  return (
    <EmptyIndicator
      description={getMessageWithPlaceholders({
        message: messages.achievementCompletionItemsCleared,
        placeholders: { date: getFormattedDate({ date }) }
      })}
      icon={icon}
      title={messages.tasksAnswers}
    />
  );
};

export default AchievementCompletionItemsCleared;
